// @flow
import styled from "styled-components";

export const Outer = styled.div`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #fff;
    cursor: pointer;

    background-image: url(https://cdn.getjealous.com/photos/fay/9499850.JPG);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
`;



// WEBPACK FOOTER //
// ./src/blog-card/photos/photo/styled.js